import ProductFinderLayout from './ProductFinderLayout';

export default ProductFinderLayout;
